import { Validator } from "./validator";
import { ICAAccount } from "./ica_account";
import * as _m0 from "protobufjs/minimal";
import { Long } from "@osmonauts/helpers";
/** next id: 19 */

function createBaseHostZone() {
  return {
    chainId: "",
    connectionId: "",
    bech32prefix: "",
    transferChannelId: "",
    validators: [],
    blacklistedValidators: [],
    withdrawalAccount: undefined,
    feeAccount: undefined,
    delegationAccount: undefined,
    redemptionAccount: undefined,
    ibcDenom: "",
    hostDenom: "",
    lastRedemptionRate: "",
    redemptionRate: "",
    unbondingFrequency: Long.UZERO,
    stakedBal: "",
    address: ""
  };
}
export const HostZone = {
  encode(message, writer = _m0.Writer.create()) {
    if (message.chainId !== "") {
      writer.uint32(10).string(message.chainId);
    }
    if (message.connectionId !== "") {
      writer.uint32(18).string(message.connectionId);
    }
    if (message.bech32prefix !== "") {
      writer.uint32(138).string(message.bech32prefix);
    }
    if (message.transferChannelId !== "") {
      writer.uint32(98).string(message.transferChannelId);
    }
    for (const v of message.validators) {
      Validator.encode(v, writer.uint32(26).fork()).ldelim();
    }
    for (const v of message.blacklistedValidators) {
      Validator.encode(v, writer.uint32(34).fork()).ldelim();
    }
    if (message.withdrawalAccount !== undefined) {
      ICAAccount.encode(message.withdrawalAccount, writer.uint32(42).fork()).ldelim();
    }
    if (message.feeAccount !== undefined) {
      ICAAccount.encode(message.feeAccount, writer.uint32(50).fork()).ldelim();
    }
    if (message.delegationAccount !== undefined) {
      ICAAccount.encode(message.delegationAccount, writer.uint32(58).fork()).ldelim();
    }
    if (message.redemptionAccount !== undefined) {
      ICAAccount.encode(message.redemptionAccount, writer.uint32(130).fork()).ldelim();
    }
    if (message.ibcDenom !== "") {
      writer.uint32(66).string(message.ibcDenom);
    }
    if (message.hostDenom !== "") {
      writer.uint32(74).string(message.hostDenom);
    }
    if (message.lastRedemptionRate !== "") {
      writer.uint32(82).string(message.lastRedemptionRate);
    }
    if (message.redemptionRate !== "") {
      writer.uint32(90).string(message.redemptionRate);
    }
    if (!message.unbondingFrequency.isZero()) {
      writer.uint32(112).uint64(message.unbondingFrequency);
    }
    if (message.stakedBal !== "") {
      writer.uint32(106).string(message.stakedBal);
    }
    if (message.address !== "") {
      writer.uint32(146).string(message.address);
    }
    return writer;
  },
  decode(input, length) {
    const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseHostZone();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          message.chainId = reader.string();
          break;
        case 2:
          message.connectionId = reader.string();
          break;
        case 17:
          message.bech32prefix = reader.string();
          break;
        case 12:
          message.transferChannelId = reader.string();
          break;
        case 3:
          message.validators.push(Validator.decode(reader, reader.uint32()));
          break;
        case 4:
          message.blacklistedValidators.push(Validator.decode(reader, reader.uint32()));
          break;
        case 5:
          message.withdrawalAccount = ICAAccount.decode(reader, reader.uint32());
          break;
        case 6:
          message.feeAccount = ICAAccount.decode(reader, reader.uint32());
          break;
        case 7:
          message.delegationAccount = ICAAccount.decode(reader, reader.uint32());
          break;
        case 16:
          message.redemptionAccount = ICAAccount.decode(reader, reader.uint32());
          break;
        case 8:
          message.ibcDenom = reader.string();
          break;
        case 9:
          message.hostDenom = reader.string();
          break;
        case 10:
          message.lastRedemptionRate = reader.string();
          break;
        case 11:
          message.redemptionRate = reader.string();
          break;
        case 14:
          message.unbondingFrequency = reader.uint64();
          break;
        case 13:
          message.stakedBal = reader.string();
          break;
        case 18:
          message.address = reader.string();
          break;
        default:
          reader.skipType(tag & 7);
          break;
      }
    }
    return message;
  },
  fromPartial(object) {
    var _object$chainId, _object$connectionId, _object$bech32prefix, _object$transferChann, _object$validators, _object$blacklistedVa, _object$ibcDenom, _object$hostDenom, _object$lastRedemptio, _object$redemptionRat, _object$stakedBal, _object$address;
    const message = createBaseHostZone();
    message.chainId = (_object$chainId = object.chainId) !== null && _object$chainId !== void 0 ? _object$chainId : "";
    message.connectionId = (_object$connectionId = object.connectionId) !== null && _object$connectionId !== void 0 ? _object$connectionId : "";
    message.bech32prefix = (_object$bech32prefix = object.bech32prefix) !== null && _object$bech32prefix !== void 0 ? _object$bech32prefix : "";
    message.transferChannelId = (_object$transferChann = object.transferChannelId) !== null && _object$transferChann !== void 0 ? _object$transferChann : "";
    message.validators = ((_object$validators = object.validators) === null || _object$validators === void 0 ? void 0 : _object$validators.map(e => Validator.fromPartial(e))) || [];
    message.blacklistedValidators = ((_object$blacklistedVa = object.blacklistedValidators) === null || _object$blacklistedVa === void 0 ? void 0 : _object$blacklistedVa.map(e => Validator.fromPartial(e))) || [];
    message.withdrawalAccount = object.withdrawalAccount !== undefined && object.withdrawalAccount !== null ? ICAAccount.fromPartial(object.withdrawalAccount) : undefined;
    message.feeAccount = object.feeAccount !== undefined && object.feeAccount !== null ? ICAAccount.fromPartial(object.feeAccount) : undefined;
    message.delegationAccount = object.delegationAccount !== undefined && object.delegationAccount !== null ? ICAAccount.fromPartial(object.delegationAccount) : undefined;
    message.redemptionAccount = object.redemptionAccount !== undefined && object.redemptionAccount !== null ? ICAAccount.fromPartial(object.redemptionAccount) : undefined;
    message.ibcDenom = (_object$ibcDenom = object.ibcDenom) !== null && _object$ibcDenom !== void 0 ? _object$ibcDenom : "";
    message.hostDenom = (_object$hostDenom = object.hostDenom) !== null && _object$hostDenom !== void 0 ? _object$hostDenom : "";
    message.lastRedemptionRate = (_object$lastRedemptio = object.lastRedemptionRate) !== null && _object$lastRedemptio !== void 0 ? _object$lastRedemptio : "";
    message.redemptionRate = (_object$redemptionRat = object.redemptionRate) !== null && _object$redemptionRat !== void 0 ? _object$redemptionRat : "";
    message.unbondingFrequency = object.unbondingFrequency !== undefined && object.unbondingFrequency !== null ? Long.fromValue(object.unbondingFrequency) : Long.UZERO;
    message.stakedBal = (_object$stakedBal = object.stakedBal) !== null && _object$stakedBal !== void 0 ? _object$stakedBal : "";
    message.address = (_object$address = object.address) !== null && _object$address !== void 0 ? _object$address : "";
    return message;
  }
};